export const Languages = [
	"AMPL",
	"ASP",
	"ApacheConf",
	"Arc",
	"Arduino",
	"AsciiDoc",
	"Assembly",
	"Astro",
	"Ballerina",
	"Batchfile",
	"Bikeshed",
	"Blade",
	"Brainfuck",
	"C",
	"C#",
	"C++",
	"CMake",
	"CSS",
	"Ceylon",
	"Clojure",
	"CodeQL",
	"CoffeeScript",
	"ColdFusion",
	"Common Lisp",
	"Coq",
	"Crystal",
	"Cuda",
	"D",
	"DTrace",
	"Dart",
	"Dockerfile",
	"Dylan",
	"EJS",
	"Elixir",
	"Elm",
	"Emacs Lisp",
	"Erlang",
	"F#",
	"Fancy",
	"Forth",
	"Fortran",
	"GDScript",
	"Gherkin",
	"Go",
	"Groovy",
	"HCL",
	"HTML",
	"Haml",
	"Handlebars",
	"Haskell",
	"IDL",
	"Java",
	"JavaScript",
	"Jsonnet",
	"Julia",
	"Jupyter Notebook",
	"Kotlin",
	"LabVIEW",
	"Less",
	"Logos",
	"Lua",
	"MATLAB",
	"MDX",
	"Makefile",
	"Markdown",
	"Mathematica",
	"Matlab",
	"Modelica",
	"MoonScript",
	"Mustache",
	"NSIS",
	"Nim",
	"Nix",
	"Nunjucks",
	"OCaml",
	"Objective-C",
	"Objective-C++",
	"PHP",
	"PLSQL",
	"PLpgSQL",
	"Papyrus",
	"Pascal",
	"Perl",
	"PostScript",
	"PowerShell",
	"Prolog",
	"Pug",
	"Python",
	"QML",
	"R",
	"RPGLE",
	"Racket",
	"Raku",
	"Ring",
	"Roff",
	"Ruby",
	"Rust",
	"SCSS",
	"Sass",
	"Scala",
	"Scheme",
	"Shell",
	"Slash",
	"Smarty",
	"Solidity",
	"Standard ML",
	"Starlark",
	"SuperCollider",
	"Svelte",
	"Swift",
	"Tcl",
	"TeX",
	"Twig",
	"TypeScript",
	"V",
	"Vala",
	"Vim Script",
	"Vim script",
	"VimL",
	"Visual Basic",
	"Vue",
	"WebAssembly",
	"Wren",
	"XSLT",
	"Yacc",
	"Zephir",
	"Zig",
	"hoon",
	"kvlang",
	"reStructuredText",
];
